var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerLedger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "distribution--ledger_1_",
    d: "M30,1.64H2C1.801,1.64,1.64,1.801,1.64,2v28c0,0.199,0.161,0.36,0.36,0.36h28 c0.199,0,0.36-0.161,0.36-0.36V2C30.36,1.801,30.199,1.64,30,1.64z M29.64,15.64h-2.28v-2.386c0-1.765-1.043-3.315-2.613-3.996 c0.559-0.493,0.894-1.209,0.894-1.978c0-1.456-1.185-2.64-2.641-2.64s-2.641,1.184-2.641,2.64c0,0.768,0.335,1.484,0.894,1.978 c-1.57,0.682-2.613,2.231-2.613,3.996v2.386h-2.28V2.36h13.28V15.64z M16.36,16.36h13.28v3.28H16.36V16.36z M22.221,9.034 C21.527,8.725,21.08,8.037,21.08,7.28c0-1.059,0.861-1.92,1.92-1.92s1.92,0.861,1.92,1.92c0,0.757-0.447,1.445-1.141,1.753 c-0.141,0.063-0.227,0.208-0.212,0.362s0.125,0.281,0.275,0.317c1.646,0.391,2.797,1.847,2.797,3.541v2.386H19.36v-2.386 c0-1.694,1.15-3.15,2.797-3.541c0.15-0.036,0.261-0.163,0.275-0.316C22.447,9.243,22.361,9.097,22.221,9.034z M15.64,15.64H2.36 V6.36h13.28C15.64,6.36,15.64,15.64,15.64,15.64z M15.64,2.36v3.28H2.36V2.36H15.64z M2.36,16.36h13.28v13.28h-2.28v-2.386 c0-1.766-1.042-3.315-2.613-3.996c0.558-0.493,0.893-1.21,0.893-1.978c0-1.456-1.184-2.641-2.64-2.641s-2.64,1.185-2.64,2.641 c0,0.768,0.335,1.484,0.893,1.978c-1.57,0.681-2.613,2.23-2.613,3.996v2.386H2.36V16.36z M8.221,23.034 C7.528,22.726,7.08,22.037,7.08,21.28c0-1.059,0.861-1.92,1.92-1.92s1.92,0.861,1.92,1.92c0,0.757-0.448,1.445-1.141,1.754 c-0.141,0.063-0.227,0.209-0.212,0.362c0.014,0.154,0.125,0.281,0.275,0.317c1.647,0.39,2.797,1.846,2.797,3.54v2.386H5.36v-2.386 c0-1.694,1.15-3.15,2.798-3.54c0.15-0.036,0.261-0.163,0.275-0.317C8.448,23.243,8.362,23.098,8.221,23.034z M16.36,29.64v-9.28 h13.28v9.279L16.36,29.64L16.36,29.64z M13,4.36H5V3.64h8V4.36z M27,17.64v0.721h-8V17.64H27z M13,9.36H5V8.64h8V9.36z M13,11.36H5 v-0.72h8V11.36z M5,13.36v-0.72h5v0.72H5z M19,22.64h8v0.721h-8V22.64z M19,24.64h8v0.721h-8V24.64z M19,26.64h5v0.721h-5V26.64z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerLedger);
export default __webpack_public_path__ + "static/media/customer-ledger.9cd92e8cf665979cc0582359b7e99094.svg";
export { ForwardRef as ReactComponent };